/**
 * Created by slavic on 4/22/16.
 */

window.App = window.App || {};
App.analytics = {
    trackedPromo: []
}

var _throttle = require('lodash/throttle');

App.initHomePageMain = function() {
    var count = 20;

    $(".mainBlocks").find("[data-ui='load-more']").on("click", function(e){
        var that = this;
        var offset = parseInt($(this).data("shown"));
        var target= $(this).data("target");

        e.preventDefault();
        var self = this;
        $.ajax({
            url: $(this).data("href"),
            data: {
                count: count,
                offset: offset
            },
            success: function(resp) {
                if (resp.success) {
                    if (resp.data == "") {
                        return $(self).remove();
                    }
                    const cards = resp.data
                        .map(item => {
                            const el = $('<a-component template="card"></a-component>');
                            el.attr(
                                'x-data',
                                `{
                                    model: ${JSON.stringify(item)},
                                    shopType: 'premium',
                                }`,
                            );
                            return el;
                        });

                    $(target).append(cards);
                    offset += 20;
                    $(that).data("shown", offset.toString());

                    // Maybe init previews on new models' tiles
                    // App.initPreviews();
                }
            }
        })
    });

    const throttleLazyLoading = _throttle(loadLazies, 100);

    function loadLazies(e) {
        let scrollTop = window.scrollY;

        let imgs = $("#home-content").find(".tile img.lazy");
        imgs.each(function(idx, img) {
            // 600px eagerness
            if($(img).offset().top-600 < (window.innerHeight + scrollTop)) {
                img.src = img.dataset.src;
                img.classList.remove('lazy');
            }
        });
        if (imgs.length==0) {
            document.removeEventListener("scroll", throttleLazyLoading);
            window.removeEventListener("resize", throttleLazyLoading);
            window.removeEventListener("orientationChange", throttleLazyLoading);
        }
    }
    document.addEventListener("scroll", throttleLazyLoading);
    window.addEventListener("resize", throttleLazyLoading);
    window.addEventListener("orientationChange", throttleLazyLoading);
    loadLazies() || $(window).on("load", loadLazies);
}

App.initHomePageSlider = function() {
    $(".main-slider .owl-carousel").on("initialized.owl.carousel", function(e) {
        $('#main-slider-spinner')?.remove();
    });

    $(".main-slider .owl-carousel").on("initialized.owl.carousel changed.owl.carousel", function(e) {
        if (e.item.index === null || $(document).scrollTop() > 200) {
            return false;
        }

        var slide = $(e.target).find(".owl-item").eq(e.item.index).find("article").first();
        var slideId = slide.data("id");

        if (App.analytics.trackedPromo.indexOf(slideId) == -1) {
            App.analytics.trackedPromo.push(slideId);

            if (App.callbacks && App.callbacks.onPromoImpression) {
                try {
                    App.callbacks.onPromoImpression(slideId, slide.data("name"));
                } catch (e) {}
            }
        }
    });

    $(".main-slider").on("click", "a", function(e) {
        var slideData = $(this).parents("article").first().data();
        if (App.callbacks && App.callbacks.onPromoClick) {
            try {
                App.callbacks.onPromoClick(slideData.id, slideData.name);
            } catch (e) {}
        }
    });


    try {
        // make a slider and don't forget to show the hidden slides (optimization thing)
        $(".main-slider .owl-carousel").owlCarousel({
            items: 1,
            mouseDrag: false,
            autoplay: true,
            autoplayTimeout: 15000,
            autoplayHoverPause: true,
            loop: true,
            lazyLoad: true,
            lazyLoadEager: 1,
        });

        $(".news-carousel").owlCarousel({
            center: true,
            autoWidth: true,
            items: 3,
            loop: true
        });
    } catch (e) {
    }


}


$(document).ready(function(){
    App.initHomePageMain();
});

$(window).on("load", function() {
    App.initHomePageSlider();
})
